import { createContext, useContext } from 'react';

export type AuthDataContextType = {
	readonly user: {
		readonly accountId: string;
		readonly picture: string | undefined;
		readonly email: string | undefined;
		readonly name: string | undefined;
		readonly locale: string | undefined;
	};
};

export const AuthDataContext = createContext<AuthDataContextType | null>(null);

export const useAuthData = () => {
	const context = useContext(AuthDataContext);
	if (!context) {
		throw new Error('useAuthData must be used within a AuthDataProvider');
	}
	return context;
};
